export const LOADING_ECOMMERCE = "LOADING_ECOMMERCE";

export const POST_ADMIN = "POST_ADMIN";

export const GET_USER = "GET_USER";

export const POST_COMPLETE_ORDER = "POST_COMPLETE_ORDER";

export const GET_ORDER = "GET_ORDER";
